import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { getAccessToken, getRefreshToken, refreshAccessToken, removeTokens } from '../services/authService';

const useAuth = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    
    const authenticate = async () => {
      const token = getAccessToken();
      if (!token) {
        sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search);
        navigate('/login');
        return;
      }

      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        if (decodedToken.exp < currentTime) {
          // Access token has expired, try refreshing
          const refreshToken = getRefreshToken();
          if (refreshToken) {
            try {
              await refreshAccessToken();
            } catch (error) {
              console.error('Token refresh failed', error);
              handleLogout();
            }
          } else {
            handleLogout();
          }
        }
      } catch (error) {
        console.error('Token decoding failed', error);
        handleLogout();
      }
    };

    const handleLogout = () => {
      removeTokens(); // Clears the tokens from storage
      sessionStorage.removeItem('redirectAfterLogin');
      navigate('/login'); // Redirects to the login page
      return
    };

    authenticate();

  }, [navigate]);
};

export default useAuth;
